import { AnyAction } from 'redux';
import { ReduxActionMeta } from '../../types/data';

export default (type: string, payload?: any, meta?: ReduxActionMeta): AnyAction => ({
  type,
  payload,
  meta: Object.assign(
    {
      __HANDLE_ERROR__: true,
      __PARSABLE__: false,
    },
    meta
  ),
});
